import { connect } from 'react-redux';
import Home from '../../../components/home/Home';
import { currentStore } from 'core/selectors';
import { getTasksProgress } from 'core/slices/tasks';
import { getCategoryProgress, resetCategory, getCategoriesData } from 'core/slices/categories';

export default connect(
  state => ({
    currentStore: currentStore(state),
  }),
  {
    getTasksProgress,
    getCategoryProgress,
    getCategoriesData,
    resetCategory,
  },
)(Home);
